import { connect } from 'react-redux';
import React, { createContext, useContext, useState, useEffect, useCallback, useReducer } from 'react';
import Button from '@mui/material/Button';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import './Css/Form.css'
import { Authentication } from '../../App'
import { purple, red, grey, pink, green, amber, orange } from '@mui/material/colors';
import CancelIcon from '@mui/icons-material/Cancel';
import ReplyIcon from '@mui/icons-material/Reply';



// Table data as a list of array.


function ApprovalDetail(props) {

    const [application_detail, setApplicationDetail] = useState([]);
    const [detail, setDetail] = useState([]);
    const [approval, setApproval] = useState([]);
    const [authorizer, setAuthorizer] = useState([]);
    const [approval_comment, setApprovalComment] = useState([]);
    const [authorizer_now, setAuthorizerNow] = useState([]);
    
    const [comments, setComments] = useState([]);

    const [user_details, setUserDetails] = useState([]);
    const [users_select, setUsersSelect] = useState([]);

    const [training_event_list, setTrainingEventList] = useState([]);//研修リスト
  
    const authentication = useContext(Authentication)
    // const token = authentication.getAccessToken();
  



    const handleComment = async(application_id, path_no) => {

        const values = {application_id:application_id, path_no:path_no, comment:comments}

        // var f = await fetch(`http://localhost:5000/v1/flw/approval/comments/insert`, { method: 'post', body: JSON.stringify(values), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/approval/comments/insert`, { method: 'post', body: JSON.stringify(values), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var d = await f.json()

        d.comment_user_name = props.users_select.filter(a=>String(a.id) == String(d.user_id))[0].user_name_all

        // todo をコピーして、新しいArrayインスタンスを作成する。
        const newApproval_comment = [...approval_comment];

        setApprovalComment(newApproval_comment.concat(d))
        // setDetail(d)

        setComments([])

    };

    const handleApproval = async(application_id, path_no, approval_flg) => {
        // alert(application_id)
        // alert(path_no)

        const values = {application_id:application_id, path_no:path_no, approval_flg:approval_flg, user_id: props.user_details.id, comment:comments}

        // var f = await fetch(`http://localhost:5000/v1/flw/authorizers/update`, { method: 'put', body: JSON.stringify(values), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/authorizers/update`, { method: 'put', body: JSON.stringify(values), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var d = await f.json()

        setComments([])

        getData(application_id)

    };

    const getTrainingEventListData = async () => {
        // const f = await fetch(`http://localhost:5000/v1/training/events/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/training/events/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setTrainingEventList(d)
    }

    const getData = async (id) => {
        // alert("ws")

        // 申請内容 flw_application
        // var f = await fetch(`http://localhost:5000/v1/flw/applications/status/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/applications/status/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var d = await f.json()
        // console.log("detail")
        // console.log(d)
        setApplicationDetail(d)
        if(d.form_id == 42){
            getTrainingEventListData()
        }

        // 申請内容
        // var f = await fetch(`http://localhost:5000/v1/flw/applications/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/applications/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var d = await f.json()
        // console.log("detail")
        // console.log(d)
        setDetail(d)

        // 承認フロー
        // f = await fetch(`http://localhost:5000/v1/flw/approvals/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/approvals/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        setApproval(d)

        // 承認者
        // f = await fetch(`http://localhost:5000/v1/flw/authorizers/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/authorizers/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        setAuthorizer(d)

        // コメント
        // f = await fetch(`http://localhost:5000/v1/flw/approval/comments/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/approval/comments/detail/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        setApprovalComment(d)

        // 現在の承認者リスト
        // f = await fetch(`http://localhost:5000/v1/flw/authorizers/now/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/authorizers/now/` + id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        setAuthorizerNow(d)
        // console.log(d)

        

    }

    const handleReApplication = async(application_id) => {
        window.open(`/reapplication/` + application_id, '_blank', 'noopener')
    }

    const handleCancel = async(application_id) => {
        alert(application_id)

        let data = {
            application_id: application_id,
        }

        // キャンセル
        // let f = await fetch(`http://localhost:5000/v1/flw/applications/cancel`, { method: 'put', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        let f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/applications/cancel`, { method: 'put', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        let d = await f.json()

        // detail
        // setDetail

        // 申請内容 flw_application
        // f = await fetch(`http://localhost:5000/v1/flw/applications/status/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/applications/status/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        // console.log("detail")
        // console.log(d)
        setApplicationDetail(d)

        // 承認フロー
        // f = await fetch(`http://localhost:5000/v1/flw/approvals/detail/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/approvals/detail/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        setApproval(d)

        // 承認者
        // f = await fetch(`http://localhost:5000/v1/flw/authorizers/detail/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/authorizers/detail/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        d = await f.json()
        setAuthorizer(d)

    }

    useEffect(() => {
        getData(props.application_id)
        setUserDetails(props.user_details)
        setUsersSelect(props.users_select)

        // console.log("ddddddddddd", props.users_select)
        
    }, [])

    
    let cnt = 0

        return (
            
            <div className='approval_detail' style={{paddingTop:30}}>

                {detail != "" ? <Grid container spacing={3}>
                        <Grid xs={6} style={{ padding: 5 }}>
                            <div style={{fontSize:16}}>
                                {"【" + application_detail.form_name + "】"}{application_detail.user_name_all}（{moment(application_detail.created_at).utc().format("YYYY-MM-DD HH:mm:ss")}）
                            </div>
                            <div style={{fontSize:16, marginLeft:10}}>
                            タイトル：{application_detail.title}
                            </div>
                        </Grid>
                        <Grid xs={6} style={{ padding: "5px 5px 5px 30px" }}>
                            {/* 0:未承認　1:承認　2:差し戻し　3:却下　4:再申請　5：申請者によるキャンセル*/}
                            {(() => {
                                if (application_detail.approval_flg == 0) {
                                  return <Alert severity="info" action={props.user_details.id == application_detail.user_id ? <Button size="small" variant="contained" onClick={() => handleCancel(props.application_id)}>申請を取り消す</Button>:""}>進行中</Alert>
                                } else if (application_detail.approval_flg == 1) {
                                  return <Alert severity="success">承認済み</Alert>
                                } else if (application_detail.approval_flg == 2) {
                                  return <Alert severity="error" icon={<ReplyIcon fontSize="inherit" />} action={props.user_details.id == application_detail.user_id ? <Button variant="contained" onClick={() => handleReApplication(application_detail.application_id)}>再申請する</Button>:""}>差し戻し</Alert>
                                } else if (application_detail.approval_flg == 3) {
                                  return <Alert severity="warning" icon={<CancelIcon fontSize="inherit" />}>却下</Alert>
                                } else if (application_detail.approval_flg == 4) {
                                  return <Alert severity="warning" icon={<CancelIcon fontSize="inherit" />}>取消</Alert>
                                }
                              })()}
                            
                        </Grid>
                        <Grid xs={6} style={{ padding: 5 }}>
                            <div style={{height : window.innerHeight-300, overflowY: "auto"}}>



                    <table className='flw_table' style={{width:"95%"}}>
                    <colgroup width='30%' />
                    <colgroup width='70%' />

                    {
                        detail.map(function (value, key) {
                            if(value.form_value != ",,,,,,,,,,,,,"){
                            return <tr>
                                <th>{value.formitem_name}</th>
                                <td>{
                                value.formitem_id == 5 && value.form_value ? value.form_value + "月" :  
                                value.formitem_id == 7 && value.form_value && value.formitem_name == "研修名選択" ? training_event_list.filter(a=>a.training_event_id == value.form_value)[0].title  :  
                                value.formitem_id == 9 && value.form_value ? value.form_value.split(",")[0] + "年" + value.form_value.split(",")[1] + "月" : 
                                value.formitem_id == 11 && value.form_value ? (value.tatemono_name ? value.tatemono_name + " " : "") + (value.room_name ? value.room_name : "") : 
                                value.formitem_id == 13 && value.form_value && props.users_select ? props.users_select.filter(a=> a.id == value.form_value)[0].user_name_all : 
                                value.formitem_id == 14 && value.form_value ? (value.tatemono_name ? value.tatemono_name + " " : "") + (value.tantou_user_name ? value.tantou_user_name : "") : 
                                value.formitem_id == 15 && value.form_value ? <div>
                                    {value.form_value.split(",")[0] ? <div>{value.form_value.split(",")[0]}</div> : ""}
                                    {value.form_value.split(",")[1] ? <div>{value.form_value.split(",")[1]}</div> : ""}
                                    {value.form_value.split(",")[2] ? <div>{"売価(月額):" + value.form_value.split(",")[2]}</div> : ""}
                                    {value.form_value.split(",")[3] ? <div>{"原価(月額):" + value.form_value.split(",")[3]}</div> : ""}
                                    {value.form_value.split(",")[4] ? <div>{"売価(年額):" + value.form_value.split(",")[4]}</div> : ""}
                                    {value.form_value.split(",")[5] ? <div>{"原価(年額):" + value.form_value.split(",")[5]}</div> : ""}
                                    {value.form_value.split(",")[6] ? <div>{"業者:" + value.form_value.split(",")[6]}</div> : ""}
                                    {value.form_value.split(",")[7] ? <div>{"開始日:" + value.form_value.split(",")[7]}</div> : ""}
                                </div>: 
                                value.formitem_id == 2 && value.form_value ? <span style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: value.form_value.length ? value.form_value.replace(/\r?\n/g, '<br/>') : '' }}></span>:
                                value.form_value}
                                 {value.formitem_id == 3 ? value.choice : ""}</td></tr>
                            }
                        })

                    }
                    </table>

                    </div>
                        </Grid>
  
                        <Grid xs={6} style={{ padding: "5px 5px 5px 30px" }}>

                        <div style={{height : window.innerHeight-300, overflowY: "auto"}}>
                    {
                        
                        approval.map(function (value, key) {
                            
                            if(authorizer.filter(a=> a.path_no == value.path_no).length > 0){
                                cnt++
                            return <div style={{display: "flex", marginBottom:10}}>
                                <div className={application_detail.status_path >= value.path_no ? "bango_now" : "bango"}>{cnt}</div>
                                {/* <TimelineSeparator>
                                <TimelineDot color={application_detail.status_path > value.path_no ? "primary" : application_detail.status_path == value.path_no ? "secondary" : "info"} style={{ opacity:application_detail.status_path >= value.path_no ? 1 : 0.5}} />
                                {approval.length > key + 1 ? <TimelineConnector color={application_detail.status_path > value.path_no ? "secondary" : ""} /> : ""}
                                </TimelineSeparator> */}
                                <div style={{marginLeft:20, textAlign:"left", width:(window.innerWidth-400)/2}}>
                                {<Chip label={value.approval_flg == 4 ? "申請者による再申請" : value.all_approval == 1 ? "誰か一人が承認" : "すべての承認が必要"} style={{ fontSize: 14,  opacity:application_detail.status_path >= value.path_no ? 1 : 0.5 }} variant="outlined" />}
                                {
                                    authorizer.filter(a=> a.path_no == value.path_no).map(function (value2) {// 0:未承認　1:承認　2:差し戻し　3:却下　4:再申請　5：申請者によるキャンセル
                                        return <div style={{marginLeft:15, marginTop:3, fontSize:14, opacity:application_detail.status_path >= value.path_no ? 1 : 0.5, textAlign:"left"}}>
                                            {value2.approval_flg <= 5 ? 
                                                <Chip label={value2.approval_flg == 0 ? "未" : 
                                                // value2.approval_flg == 1 ? "承" :
                                                value2.approval_flg == 1 ? value.approval_type_name.charAt(0) :
                                                value2.approval_flg == 2 ? "差" :
                                                value2.approval_flg == 3 ? "却" :
                                                value2.approval_flg == 4 ? "再申請" :
                                                value2.approval_flg == 5 ? "申請者によるキャンセル" : ""
                                                } 
                                            color={value2.approval_flg == 4 || value2.approval_flg == 5 ? "default" : value2.approval_flg == 1 || value2.approval_flg == 2 ? "primary" : "secondary"} 
                                            variant={value2.approval_flg == 0 ? "outlined" : "default"} size="small"
                                            /> : ""}
                                            <span style={{marginLeft:5}}>{value.approval_flg != 4 && value2.approval_flg != 5 ? value.approval_type_name : "申請"}者：{value2.authorizers_name}{value2.approval_at ? "(" + moment(value2.approval_at).utc().format("YYYY-MM-DD HH:mm:ss") + ")" : ""}</span>

                                            </div>
                                    })
                                }
                                {
                                    approval_comment.filter(a=> a.path_no == value.path_no).map(function (value2) {// 0:未承認　1:承認　2:差し戻し　3:却下　4:再申請　5：申請者によるキャンセル
                                        return <div style={{marginLeft:45, marginTop:10}}>
                                                
                                                {value2.comment_user_name}：{value2.comment}{value2.comment_at ? "(" + moment(value2.comment_at).format("YYYY-MM-DD HH:mm:ss") + ")" : ""}
                                            </div>
                                    })
                                }
                                {/* <span>aaaa:{value.approval_flg}</span> */}
                                {
                                    application_detail.status_path == value.path_no && value.approval_flg == 0 && application_detail.approval_flg != 3 ? <div style={{marginLeft:15, marginTop:10}}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            label="コメント"
                                            multiline
                                            rows={5}
                                            name="comments"
                                            onChange={(e)=>setComments(e.target.value)}
                                            value={comments}
                                            variant="outlined"
                                            fullWidth
                                        />
                                        <Button style={{ float: "right", margin: 5 }} variant="outlined" onClick={() => handleComment(value.application_id, value.path_no)}>コメントする</Button>
                                        {/*未承認かつ　現在の承認者なら、承認、差し戻し、却下ボタン　*/}
                                        {authorizer_now.filter(a=>a.user_id == props.user_details.id && a.authorizer_approval_flg == 0).length > 0 ? <Button style={{ float: "right", margin: 5, backgroundColor:amber['500'], color:"white" }} variant="contained" color="secondary" onClick={() => handleApproval(value.application_id, value.path_no, 3)}>却下</Button> : ""}
                                        {authorizer_now.filter(a=>a.user_id == props.user_details.id && a.authorizer_approval_flg == 0).length > 0 ? <Button style={{ float: "right", margin: 5, backgroundColor:pink['500'], color:"white" }} variant="contained" onClick={() => handleApproval(value.application_id, value.path_no, 2)}>差戻</Button> : ""}
                                        {authorizer_now.filter(a=>a.user_id == props.user_details.id && a.authorizer_approval_flg == 0).length > 0 ? <Button style={{ float: "right", margin: 5, backgroundColor:green['500'], color:"white"}} variant="contained" color="primary" onClick={() => handleApproval(value.application_id, value.path_no, 1)}>承認</Button> : ""}
                                    </div>:""
                                }
                                </div>
                                {/* </TimelineContent> */}
                            </div>
                            }
                        })
                    }
                        </div>
                        </Grid>

                    </Grid> : ""}

                </div>

            );
};

// const mapStateToProps = (state) => {
//     return {
//       user_details: state.masterReducer.user_details,
//       users_select: state.masterReducer.users_select,
//     }
//   }

// export default connect(mapStateToProps)(App);
export  default ApprovalDetail;